// extracted by mini-css-extract-plugin
export default {"sneakers":"Sneakers_sneakers__YXKhp"};